import { ETalkingPointAiSource } from '@enums/campaign-analytics.enum';
import { ISegmentedControlOption } from '@shared/components/segmented-control/segmented-control.interface';
import {
  ITalkingPointAiStreamAnalyticsTableData,
  TTalkingPointAiSourceFilter,
} from './talking-point-ai-stream-analytics.interface';

export function filterTalkingPointAiRowsBySource(
  rows: ITalkingPointAiStreamAnalyticsTableData[],
  sourceFilter: TTalkingPointAiSourceFilter,
): ITalkingPointAiStreamAnalyticsTableData[] {
  return sourceFilter === 'all' ? rows : rows.filter((row) => row.source === sourceFilter);
}

export function buildTalkingPointAiSourceFilterOptions(
  rows: ITalkingPointAiStreamAnalyticsTableData[],
): ISegmentedControlOption<TTalkingPointAiSourceFilter>[] {
  const countFor = (sourceFilter: TTalkingPointAiSourceFilter): number =>
    filterTalkingPointAiRowsBySource(rows, sourceFilter).length;

  return [
    { count: countFor('all'), label: 'shared.all', value: 'all' },
    {
      count: countFor(ETalkingPointAiSource.transcript),
      icon: 'icons/microphone.svg',
      label: 'pages.campaignDetails.ctaAnalytics.details.talkingPointAi.sourceType.transcript',
      value: ETalkingPointAiSource.transcript,
    },
    {
      count: countFor(ETalkingPointAiSource.chat),
      icon: 'icons/chat.svg',
      label: 'pages.campaignDetails.ctaAnalytics.details.talkingPointAi.sourceType.chat',
      value: ETalkingPointAiSource.chat,
    },
  ];
}
